import {throttle, toggleElement} from "./helpers";

(function () {
  const mainNav = document.querySelector('.nav-main ul')
  const hamburger = document.querySelector('.hamburger')
  const body = document.querySelector('body')
  const childMenuItems = document.querySelectorAll('.menu-item-has-children')
  const throttledFn = throttle(changeHeaderLayout)

  function changeHeaderLayout() {
    let headerTop = document.querySelector('[data-header-top]');
    let headerTopWrapper = document.querySelector('[data-header-top-wrapper]');
    if (window.innerWidth < 992 && !mainNav.contains(headerTopWrapper)) mainNav.appendChild(headerTopWrapper)
    if (window.innerWidth > 992 && !headerTop.contains(headerTopWrapper)) headerTop.appendChild(headerTopWrapper)
  }

  function toggleMobileMenu() {
    hamburger.classList.toggle('openned')
    if (hamburger.classList.contains('openned')) {
      toggleElement(mainNav, true)
      body.classList.add('disable-scroll')
    } else {
      toggleElement(mainNav, false)
      body.classList.remove('disable-scroll')
    }
  }

  function hideOtherItems(current = null, elements) {
    elements?.forEach(item => {
      const condition = item.matches('.shown') && item !== current
      if (condition) toggleElement(item, false)
    })
  }

  async function handleSubmenuToggle(e) {

    if (!e.target.closest('.dropdown') && !e.target.matches('.menu-item-has-children > a')) {
      hideOtherItems(null, childMenuItems)
    }

    if (e.target.closest('.menu-item:is(:not(.menu-item-has-children))') || !e.target.closest('.menu-item')) return

    e.preventDefault();

    if (!e.target.matches('.menu-item-has-children > a')) return
    const clickedMenuItemWithChildren = e.target.closest('.menu-item-has-children')
    const isMenuItemHasClass = clickedMenuItemWithChildren.matches('.shown')

    if (window.innerWidth >= 993) {
      hideOtherItems(clickedMenuItemWithChildren, childMenuItems)

      if (!isMenuItemHasClass) {
        await toggleElement(clickedMenuItemWithChildren, true)
      } else {
        await toggleElement(clickedMenuItemWithChildren, false)
      }
    } else {
      if (!isMenuItemHasClass) {
        await toggleElement(clickedMenuItemWithChildren, true)
      } else {
        await toggleElement(clickedMenuItemWithChildren, false)
      }
    }
  }

  hamburger?.addEventListener('click', toggleMobileMenu)
  document.addEventListener('click', handleSubmenuToggle);
  window.addEventListener('DOMContentLoaded', changeHeaderLayout)
  window.addEventListener('resize', throttledFn)
})()
